// extracted by mini-css-extract-plugin
module.exports = {"circleRight":"UnsavedChangesButton_circleRight___e5wC","button":"UnsavedChangesButton_button__EWrKo"};